module.exports = __webpack_public_path__ + "img/car-B-1.0ace1f2a.jpg";